import ADD_PRODUCT_FUNCTION from 'api/mutations/ADD_PRODUCT_FUNCTION';
import REMOVE_PRODUCT_FUNCTION from 'api/mutations/REMOVE_PRODUCT_FUNCTION';
import UPDATE_PRODUCT_FUNCTION from 'api/mutations/UPDATE_PRODUCT_FUNCTION';
import GET_PRODUCT_FUNCTIONS from 'api/queries/GET_PRODUCT_FUNCTIONS';
import { createProductParameterSlice } from './createProductParameterSlice';
const productFunctionsSlice = createProductParameterSlice({
    name: 'productFunctions',
    stateKey: 'productFunctions',
    query: GET_PRODUCT_FUNCTIONS,
    addMutation: ADD_PRODUCT_FUNCTION,
    updateMutation: UPDATE_PRODUCT_FUNCTION,
    removeMutation: REMOVE_PRODUCT_FUNCTION,
    idVariableName: 'productFunctionId',
    selectConnection: (data) => data.autocomplete.productFunctions,
    selectAddedItem: (data) => data.addProductFunction.productFunction,
    selectUpdatedItem: (data) => data.updateProductFunction.productFunction,
});
export const resetProductFunctions = productFunctionsSlice.reset;
export const fetchProductFunctions = productFunctionsSlice.fetchItems;
export const addProductFunction = productFunctionsSlice.addItem;
export const updateProductFunction = productFunctionsSlice.updateItem;
export const removeProductFunction = productFunctionsSlice.removeItem;
export const selectProductFunctions = productFunctionsSlice.selectItems;
export const selectProductFunctionById = productFunctionsSlice.selectItemById;
export const selectProductFunctionsPageInfo = productFunctionsSlice.selectPageInfo;
export const selectProductFunctionsStatus = productFunctionsSlice.selectStatus;
export const selectProductFunctionsErrors = productFunctionsSlice.selectErrors;
export const selectProductFunctionsRefetchFlags = productFunctionsSlice.selectRefetchFlags;
export default productFunctionsSlice.reducer;
